import { render } from "./ContentSummary.vue?vue&type=template&id=d0fe77c0"
import script from "./ContentSummary.vue?vue&type=script&lang=js"
export * from "./ContentSummary.vue?vue&type=script&lang=js"

import "./ContentSummary.vue?vue&type=style&index=0&id=d0fe77c0&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__